<template>
	<div class="index">
		<van-nav-bar left-text="意见反馈" left-arrow @click-left="onClickLeft" @click-right="onClickRight" />
		<div class="content">
			<h5 style="color: #444;
    		font-size: var(--base-px-14);
    		font-weight: 500;"
		>内容描述</h5>
			<van-field style="    background: #f6f6f6;" v-model="message" rows="2"
				:autosize="{ maxHeight: 300, minHeight: 170 }" type="textarea" maxlength="300" placeholder="在这里说说你的宝贵意见"
				show-word-limit />
			<van-uploader style="margin-top: var(--base-px-10);" :after-read="afterRead" />

			<van-button type="info" block style="width: 100%; margin-top: var(--base-px-30);">提交</van-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// 文字
			message: '',
			// tbas切换
			tabsChose: 0
		}
	},
	watch: {},
	methods: {}
}
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar__content {
	background: #2b63cd;
	color: #fff;
}

/deep/ .van-nav-bar .van-icon {
	color: #fff;
}

/deep/ .van-nav-bar__text {
	color: #fff;
}

/deep/ .van-nav-bar__title {
	color: #fff;
}

.index {
	font-size: var(--base-px-14);
	height: 100%;
	background: #fff;

	p {
		margin: 0 !important;
	}

	.fs14 {
		font-size: var(--base-px-14);
	}

	.fs16 {
		font-size: var(--base-px-16);
	}

	.content {
		padding: var(--base-px-22) var(--base-px-23);
		height: 93%;

		.kf-card {
			background: #fff;
			border-radius: var(--base-px-4);
			padding: var(--base-px-24) var(--base-px-30) var(--base-px-50);
			height: var(--base-px-398);

			.name {
				display: flex;
				-webkit-box-align: center;
				align-items: center;

				.bold {
					font-size: var(--base-px-17);
					line-height: var(--base-px-17);
					color: #000;
					margin-left: var(--base-px-14);
				}

				img {
					width: var(--base-px-46);
					height: var(--base-px-50);
				}
			}

			.qr {
				width: var(--base-px-229);
				height: var(--base-px-229);
				margin: var(--base-px-10) auto 0;
				display: block;
			}

			.tips {
				margin-top: var(--base-px-15);
				text-align: center;
				font-size: var(--base-px-15);
				line-height: var(--base-px-22-15);
				color: #444;
				margin-top: var(--base-px-17) !important;

				img {
					vertical-align: middle;
					width: var(--base-px-16);
					height: var(--base-px-20);
					margin-right: var(--base-px-9);
				}
			}
		}
	}

}
</style>
